export default __webpack_public_path__ + "static/media/FD-Submittal.840890ec.pdf";